import { Component, Inject, Input, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'

@Component({
  selector: 'gb-login-to-proceed-dialog',
  templateUrl: './gb-login-to-proceed-dialog.component.html',
  styleUrls: ['./gb-login-to-proceed-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GbLoginToProceedDialogComponent {
  displaySocialLogin$ = this.auctionFacade.displaySocialLogin$

  title = (this.data && this.data.title) || 'AUTH.LOGIN_TO_PROCEED_DEFAULT_TITLE'

  constructor(private auctionFacade: AuctionFacade, @Inject(MAT_DIALOG_DATA) public data: { title: string }) {}
}
